import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { CommentContentRenderer as p } from "../components/CommentContentRenderer/index.js";
import { Author as a } from "../style.js";
import { CommentBadgeType as d } from "../types.js";
import { TipContainer as h, TipBadge as l, TipContent as c, TipAvatar as f } from "./style.js";
const x = ({
  image: t,
  title: o,
  message: n,
  className: i,
  clickoutFunction: m
}) => /* @__PURE__ */ r(h, { className: i, children: [
  /* @__PURE__ */ e(l, { type: d.TIP }),
  /* @__PURE__ */ e(
    c,
    {
      header: /* @__PURE__ */ r(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
          },
          children: [
            /* @__PURE__ */ e(f, { author: "Foguinho", authorImage: t }),
            /* @__PURE__ */ e(a, { children: o })
          ]
        }
      ),
      content: /* @__PURE__ */ e(p, { clickoutFunction: m, children: n })
    }
  )
] });
export {
  x as TipComment
};
